import * as p2cService from '@api/person-content';
import { AppBarTitle } from '@components/app-bar-title';
import { DealDetail, DealStatus } from '@lib/deals';
import { IconButton } from '@material-ui/core';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { P2CAddForm } from './form';

export default function AddP2C() {
  let deal: DealDetail = {
    id: null,
    entity1: null,
    entity1_type: null,
    entity2: null,
    entity2_type: null,
    status: DealStatus.notReviewed,
    published_date: null,
    confidence: 0,
    relation: null,
    sentences: [],
  };

  // To set duplicate deal values, get deal id from queryParam
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();

  // Form Actions
  const createDeal = useCallback(payload => {
    const infoNotification = enqueueSnackbar('Please wait Creating P2C relation', { variant: 'info' });
    return p2cService.post(payload).subscribe({
      next: () => {
        enqueueSnackbar('P2C Relation Created Successfully!', { variant: 'success' });
        history.push('/person-content/search');
      },
      error: err => enqueueSnackbar(`Error Creating P2C relation (${err?.response?.data?.error})`, { variant: 'error' }),
      complete: () => closeSnackbar(infoNotification),
    })
  }, []);

  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <SpellcheckRoundedIcon />
        </IconButton>
        New P2C
      </AppBarTitle>
      <P2CAddForm deal={deal} onSubmit={createDeal} />
    </div>
  );
} 